const SDK_VERSION = "11.8.0" ;

export { SDK_VERSION };
//# sourceMappingURL=version.js.map
